import { observer } from 'mobx-react-lite';
import { colors } from '../../../../../../../../../../../colorVars';
import { BoxInput } from '../../../../../../../../../../atomic/inputs/boxInput/BoxInput';
import { Body3, fontSizes } from '../../../../../../../../../../atomic/text/Text';
import { AlertForm, useAlertFormStore } from '../../../../../alertFormClass';
import style from './BreakSetupModule.module.css';

export const BreakSetupModule = observer(() => {

  const form:AlertForm = useAlertFormStore();
  if(!form) return null;

  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Break
        </Body3>
      </header>
      <div className={style.body}>
      <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Break Price
          </Body3>
          <BoxInput
            value={form.setupDetails['BREAK'].priceToBreak}
            setValue={(value) =>
              form.setupDetails['BREAK'].setBreakPrice(value)
            }
            backgroundColor={colors.grey}
            fontSize={fontSizes.body3}
            width="50px"
            height="20px"
            direction="left"
            symbol="$"
          />
        </div>
      </div>
    </div>
  );
});
